var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMchoiceAnswerIncorrectIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2.5,
    fill: "red"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mchoice_answer_incorrect_ic_svg__clip0_1452_4666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.755 14.816a.75.75 0 001.061-1.06L11.061 10l3.755-3.755a.75.75 0 10-1.06-1.061L10 8.939 6.245 5.184a.75.75 0 10-1.061 1.06L8.939 10l-3.755 3.755a.75.75 0 101.06 1.061L10 11.061l3.755 3.755z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mchoice_answer_incorrect_ic_svg__clip0_1452_4666"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 5 10)",
    d: "M0 0h10v10H0z"
  })))));
}
export default SvgMchoiceAnswerIncorrectIc;